import { useState } from "react";
import { ApiClientError } from "../../lib/api/client";
import { useCreateDonorMutation } from "../../lib/api/donors";
import { Button } from "../../components/ui/Button";
import { Modal } from "../../components/ui/Modal";

interface CreateDonorModalProps {
  open: boolean;
  onClose: () => void;
  onCreated?: (donorId: string) => void;
}

export function CreateDonorModal({ open, onClose, onCreated }: CreateDonorModalProps) {
  const createDonor = useCreateDonorMutation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("Family foundation");
  const [note, setNote] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setError(null);
    try {
      const result = await createDonor.mutateAsync({
        name,
        email: email || undefined,
        type,
        note: note || undefined,
      });
      onCreated?.(result.donor.id);
      onClose();
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Could not create donor.");
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add donor"
      description="After saving, add a restricted fund linked to one or more programmes so the donor appears in reports."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={createDonor.isPending} onClick={() => void submit()}>
            {createDonor.isPending ? "Saving…" : "Save donor"}
          </Button>
        </>
      }
    >
      <div className="grid gap-4">
        {error ? (
          <p className="edlab-error">
            {error}
          </p>
        ) : null}
        <label className="grid gap-1 text-sm">
          Name
          <input
            className="edlab-input"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </label>
        <label className="grid gap-1 text-sm">
          Email
          <input
            type="email"
            className="edlab-input"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </label>
        <label className="grid gap-1 text-sm">
          Type
          <input
            className="edlab-input"
            value={type}
            onChange={(e) => {
              setType(e.target.value);
            }}
          />
        </label>
        <label className="grid gap-1 text-sm">
          Note
          <textarea
            className="edlab-input"
            rows={3}
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
            }}
          />
        </label>
      </div>
    </Modal>
  );
}
